// extracted by mini-css-extract-plugin
export default {"chips":"chips_chips__sj+z2","chip":"chips_chip__I74nm","delete_chip":"chips_delete_chip__ida6n"};